<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
            <el-button 
              type="text" 
              style="float: right; padding: 3px 0" 
              @click="_moreCondition()">
              {{auditEnterCommunityManageInfo.moreCondition ? '隐藏' : '更多'}}
            </el-button>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-input 
                v-model="auditEnterCommunityManageInfo.conditions.name" 
                placeholder="请输入商户名称"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="8">
              <el-input 
                v-model="auditEnterCommunityManageInfo.conditions.communityName" 
                placeholder="请输入小区名称"
                clearable>
              </el-input>
            </el-col>
            <el-col :span="6">
              <el-select 
                v-model="auditEnterCommunityManageInfo.conditions.auditStatusCd" 
                placeholder="请选择审核状态"
                style="width:100%">
                <el-option label="请选择审核状态" value=""></el-option>
                <el-option label="未审核" value="1000"></el-option>
                <el-option label="审核通过" value="1100"></el-option>
                <el-option label="审核未通过" value="1200"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-button 
                type="primary" 
                icon="el-icon-search" 
                @click="_queryEnterCommunityMethod()">
                查询
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="auditEnterCommunityManageInfo.moreCondition">
            <el-col :span="8">
              <el-select 
                v-model="auditEnterCommunityManageInfo.conditions.memberTypeCd" 
                placeholder="请选择商户类型"
                style="width:100%">
                <el-option label="请选择商户类型" value=""></el-option>
                <el-option label="物业公司" value="390001200002"></el-option>
                <el-option label="代理商" value="390001200003"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-input 
                v-model="auditEnterCommunityManageInfo.conditions.tel" 
                placeholder="请输入联系电话"
                clearable>
              </el-input>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top:20px">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>商户审核</span>
          </div>
          <el-table
            :data="auditEnterCommunityManageInfo.communitys"
            border
            style="width: 100%">
            <el-table-column
              prop="communityId"
              label="小区ID">
            </el-table-column>
            <el-table-column
              prop="name"
              label="小区名称">
            </el-table-column>
            <el-table-column
              prop="storeName"
              label="商户名称">
            </el-table-column>
            <el-table-column
              prop="storeTypeName"
              label="商户类型">
            </el-table-column>
            <el-table-column
              prop="tel"
              label="联系电话">
            </el-table-column>
            <el-table-column
              prop="address"
              label="商户地址">
            </el-table-column>
            <el-table-column
              prop="stateName"
              label="状态">
            </el-table-column>
            <el-table-column
              label="操作"
              width="180"
              align="right">
              <template slot-scope="scope">
                <el-button 
                  v-if="scope.row.auditStatusCd=='1000'" 
                  size="mini" 
                  @click="_openEnterAuditCommunityModal(scope.row)">
                  审核
                </el-button>
                <el-button 
                  v-if="scope.row.auditStatusCd!='1000'" 
                  size="mini" 
                  @click="_openRecallAuditFinishCommunityModal(scope.row)">
                  撤回审核
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="auditEnterCommunityManageInfo.conditions.page"
            :page-size="auditEnterCommunityManageInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="auditEnterCommunityManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <audit 
      ref="audit"
      @notifyAuditInfo="_auditEnterCommunityState">
    </audit>
    <recall-audit-enter-finish-community 
      ref="recallAuditEnterFinishCommunity">
    </recall-audit-enter-finish-community>
  </div>
</template>

<script>
import { listCommunitys, auditCommunity } from '@/api/common/auditEnterCommunityManageApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AuditEnterCommunityManage',
  components: {
    'audit': () => import('@/components/common/audit/Audit'),
    'recall-audit-enter-finish-community': () => import('@/components/common/recallAuditEnterFinishCommunity/recallAuditEnterFinishCommunity')
  },
  data() {
    return {
      auditEnterCommunityManageInfo: {
        communitys: [],
        total: 0,
        records: 1,
        currentCommunityMemberId: '',
        moreCondition: false,
        conditions: {
          name: '',
          memberTypeCd: '',
          communityName: '',
          auditStatusCd: '1000',
          tel: '',
          page: 1,
          row: 10
        }
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
    this._listCommunitys(1, 10)
  },
  methods: {
    async _listCommunitys(page, rows) {
      this.auditEnterCommunityManageInfo.conditions.page = page
      this.auditEnterCommunityManageInfo.conditions.row = rows
      try {
        const res = await listCommunitys(this.auditEnterCommunityManageInfo.conditions)
        this.auditEnterCommunityManageInfo.total = res.total
        this.auditEnterCommunityManageInfo.records = res.records
        this.auditEnterCommunityManageInfo.communitys = res.communitys
      } catch (error) {
        console.error('获取商户列表失败:', error)
      }
    },
    _openEnterAuditCommunityModal(community) {
      this.auditEnterCommunityManageInfo.currentCommunityMemberId = community.communityMemberId
      this.$refs.audit.open()
    },
    _openRecallAuditFinishCommunityModal(community) {
      this.$refs.recallAuditEnterFinishCommunity.open(community)
    },
    async _auditEnterCommunityState(auditInfo) {
      auditInfo.communityMemberId = this.auditEnterCommunityManageInfo.currentCommunityMemberId
      try {
        await auditCommunity(auditInfo)
        this.$message.success('操作成功')
        this._listCommunitys(1, 10)
      } catch (error) {
        console.error('审核失败:', error)
        this.$message.error('操作失败')
      }
    },
    _queryEnterCommunityMethod() {
      this._listCommunitys(1, 10)
    },
    _moreCondition() {
      this.auditEnterCommunityManageInfo.moreCondition = !this.auditEnterCommunityManageInfo.moreCondition
    },
    handleCurrentChange(val) {
      this._listCommunitys(val, this.auditEnterCommunityManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-col {
  width: 100%;
}
</style>